import { render, staticRenderFns } from "./shouldhaveother.vue?vue&type=template&id=68e3e0a2&scoped=true&"
import script from "./shouldhaveother.vue?vue&type=script&lang=js&"
export * from "./shouldhaveother.vue?vue&type=script&lang=js&"
import style0 from "./shouldhaveother.vue?vue&type=style&index=0&id=68e3e0a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3e0a2",
  null
  
)

export default component.exports